import {
  Component,
  EventEmitter,
  Inject,
  Input,
  LOCALE_ID,
  Output,
  SimpleChanges,
} from '@angular/core';
import { CommonModule, formatDate } from '@angular/common';
import { FormControl, FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import {
  MatDatepickerInputEvent,
  MatDatepickerModule,
} from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';

export interface SearchField {
  value: string;
  displayName: string;
}

@Component({
    selector: 'app-search-bar',
    imports: [
        CommonModule,
        FormsModule,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        MatDatepickerModule,
        MatNativeDateModule
    ],
    providers: [MatDatepickerModule
    ],
    templateUrl: './search-bar.component.html',
    styleUrl: './search-bar.component.scss'
})
export class SearchBarComponent {
  @Input() fields: SearchField[] = [];
  @Input() defaultField: string = '';
  @Input() placeholder: string = '';
  @Input() isDetailView: boolean = false;
  @Input() activeSearch: { field: string; value: string };
  @Output() search = new EventEmitter<{ field: string; value: string }>();
  selectedField: string = '';
  searchText: string = '';
  hasActiveDateSearch: boolean = false;
  picker: string = '';
  inputControl: FormControl;
  constructor(@Inject(LOCALE_ID) private locale: string) {}

  ngOnInit(): void {
    if (!this.activeSearch) {
      this.selectedField = this.defaultField;
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['activeSearch'] && changes['activeSearch'].currentValue) {
      const search = changes['activeSearch'].currentValue;
      if (this.isDateField(search.field)) {
        this.selectedField = search.field;
        this.searchText = this.searchText;
        return;
      }
      this.selectedField = search.field;
      this.searchText = search.value;
    }
  }

  applyFilter(isDate?: boolean) {
    if (isDate) {
      this.search.emit({
        field: this.selectedField,
        value: formatDate(this.searchText, 'MM/dd/yyyy', this.locale),
      });
    } else {
      if (!this.selectedField || !this.searchText.trim()) {
        this.clearSearch();
        return;
      }

      this.search.emit({
        field: this.selectedField,
        value: this.searchText.trim(),
      });
    }
  }

  clearSearch() {
    this.selectedField = this.defaultField;
    this.searchText = '';
    this.hasActiveDateSearch = false;
    this.search.emit(null);
  }

  onFieldChange(): void {
    this.searchText = '';
    this.hasActiveDateSearch = false;
  }

  onDateChange(date: MatDatepickerInputEvent<any, any>) {
    this.hasActiveDateSearch = !!date.value;
    this.applyFilter(true);
  }

  private isDateField(selectedField: string): boolean {
    return ['SubmissionCreateDate', 'SoldDate'].includes(selectedField);
  }
}
